import { useSelector } from 'react-redux'
import { RootState } from 'reducers/rootReducer'
import { TranslationKeys } from 'types/TranslationKeys'
import { reverseArray } from 'utils/reverseArray'

export interface PrinciplesProps {
  isAr: boolean
  t: (key: TranslationKeys) => string
}

export const usePrinciples = (props: PrinciplesProps) => {
  const principlesData = useSelector(
    (state: RootState) => state.about.principles
  )

  const animations = ['lightSpeedInRight', 'lightSpeedInLeft']
  const animationsReversed = reverseArray(animations)

  return {
    ...props,
    principlesData,
    animations,
    animationsReversed,
  }
}
